// Turns a link the assistant wrote (or a navigate effect) into an in-app path
// for the router. Absolute links count only on the app's own origins; any
// other URL is external and is opened as a normal link, never navigated to.

const DEFAULT_APP_ORIGINS = ['https://app.autoclipper.live'];

export function resolveInternalPath(
  href: unknown,
  appOrigins: readonly string[] = DEFAULT_APP_ORIGINS,
): string | null {
  if (typeof href !== 'string' || href.length === 0 || href.length > 2048) return null;
  if (/[\s\\]/.test(href)) return null;
  if (href.startsWith('/')) {
    return href.startsWith('//') ? null : href;
  }
  let url: URL;
  try {
    url = new URL(href);
  } catch {
    return null;
  }
  if (!appOrigins.includes(url.origin)) return null;
  return `${url.pathname}${url.search}${url.hash}` || '/';
}
